<template>
	<div>
		<div>
			<div class="flexB" style="width: 98%;">
				<h4>视频（共{{total}}条）</h4>
				<div class="flexC">
					<el-input placeholder="请输入视频名称" v-model="pushData.name" @keyup.enter="search()" class="marginR10" style="width: 200px;">
						<template #suffix>
							<el-icon class="el-input__icon">
								<component :is="Search" class="enter-sj" @click="search()"></component>
							</el-icon>
						</template>
					</el-input>
					<el-button type="primary" color='#112DF2' @click="add">上传</el-button>
				</div>
			</div>
			<div class="tablePage">
				<el-table :data="tableData" :empty-text="emptyText" style="width: 100%;margin-top: 30px;">
					<el-table-column prop="merchantName" label="名称" min-width="260px">
						<template #default="scope">
							<div class="flexA">
								<video style="margin-right: 10px;" :id="'videoElement_' + scope.$index" controls @loadedmetadata="handleMetadata('videoElement_' + scope.$index)">
									<source :src="scope.row.url" type="video/mp4">
								</video>
								<div class="textL cardInfo">
									<p>{{scope.row.name}}</p>
									<p>{{scope.row.url}}</p>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="createdTime" label="上传时间"></el-table-column>
					<el-table-column prop="createdTime" label="操作">
						<template #default="scope">
							<el-button link type="primary" plain color="#112DF2" @click="delPro(scope.row.id)">删除</el-button>
							<el-button link type="primary" plain color="#112DF2" @click="copyText(scope.row.url)">复制</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="paginations">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="prev, pager, next" :total="total">
			</el-pagination>
		</div>
		<el-dialog title="视频上传" width="800" :model-value="dialogVisible" :before-close="closeDialog">
			<el-form :model="videoData" ref="formBox" :rules="rules" label-width="180px" class="formBox">
				<el-form-item label="视频名称：" prop="name">
					<el-input style="max-width: 500px;" v-model="videoData.name" maxlength="6" show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="视频上传：" prop="shopId">
					<el-upload v-if="!isVideo&&(uploadProgress==0)" class="uploadLists" name='files' :data="uploadData" :headers="importHeaders" ref="upload" action="" :http-request="handleBeforeUpload" :file-list="fileListData" accept="video/mp4,video/mov" list-type="picture-card" :limit="1" :on-preview="handlePictureCardPreview" :on-exceed="handleExceed" :beforeUpload="beforeAvatarUpload" :on-success="(response, file, fileList)=>{return uploadSuccess(response, file, fileList,1)}" :on-remove="(file,fileList)=>{return handleRemove(file,fileList,1)}">
						<!-- <el-icon><Plus /></el-icon> -->
						<el-icon class="el-icon--upload"><upload-filled /></el-icon>
					</el-upload>
					<!-- 进度条 -->
					<el-progress
					  v-if="uploadProgress > 0 && uploadProgress < 100"
					  :percentage="uploadProgress"
					  :status="uploadStatus"
					  style="margin-top: 20px;"
					></el-progress>
					<video controls v-if="isVideo" style="width: 200px;">
						<source :src="ossVideoUrl" type="video/mp4">
					</video>
					<div class="tips">
						<div>注意：</div>
						<div>1、使用mp4、mov格式的视频文件</div>
						<div>2、推荐上传720P（1080*720）及以上视频</div>
						<div>3、支持500M以内的视频文件</div>
					</div>
					<!-- <el-dialog v-model="dialogVisible1">
					    <img w-full :src="dialogImageUrl" alt="Preview Image" />
					</el-dialog> -->
				</el-form-item>
			</el-form>
			<template #footer>
				<div class="flexAR">
					<el-button type="primary" color="#787878" @click="closeDialog">取消</el-button>
					<el-button class="marginR10" type="primary" color="#112DF2" @click="save">保存</el-button>
				</div>
			</template>
		</el-dialog>
	</div>
</template>

<script>
	import {videoPageList,videoDeleteById,uploadNormal,userLogin,videoCreate,getPreSignedUrl} from '@/api'
	import {formatDateOrder,dateFormat} from '@/utils/data'
	import axios from 'axios'
	import { Search } from "@element-plus/icons-vue";
	export default {
		data () {
			return {
				uploadNormal,
				importHeaders:{
					'Authorization':''
				},
				uploadData:{folder:'cms/video/'},
				fileListData:[],
				videosUrl:[],
				dialogImageUrl:'',
				ossVideoUrl:'',
				isVideo:false,
				dialogVisible:false,
				dialogVisible1:false,
				Search,
				pushData:{
					name:''
				},
				videoData:{
					name:''
				},
				uploadProgress: 0, // 上传进度
				tableData:[],
				pageSize: 5,	
				pageNum: 1,
				total:0,
				emptyText:'暂无数据',
				rules: {
					name: [{required: true,message: '请输入视频名称', trigger: 'blur'}]
				}
			}
		},
		created() {
			this.search()
		},	
		methods:{
			handleBeforeUpload(file){
				let fileExtensionName = file.file.name.split('.').pop()
				let data = {
					folder:'cms/video/',
					fileExtensionName,
					contentType:file.file.type
				}
				// oss:'https://static.shiyueji.net/cms/video/677e4ba540f0a705ae3ad2db1b61eeb8.mp4',
				this.fileListData = []
				getPreSignedUrl({data}).then(res=>{
					axios.put(res.data.preSignedUrl,file.file,{
						headers: {
							// 'Content-Type': 'application/x-www-form-urlencoded'// 使用文件的实际MIME类型
							'Content-Type': data.contentType // 使用文件的实际MIME类型
						},
						onUploadProgress: (progressEvent) => {
							if (progressEvent.total) {
								this.uploadProgress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
							}
						},
					}).then(response=>{
						if(response.status == 200){
							this.isVideo = true
							this.ossVideoUrl = res.data.accessUrl
						}
					}).catch(err => {
						console.log(err); // 上传失败的处理逻辑。
					});
				})
			},
			search(){
				let postData = {
					 "paging": {
						"pageNum": this.pageNum,
						"pageSize": this.pageSize
					}
				}
				postData = Object.assign(postData, this.pushData)
				videoPageList(postData).then(res => {
					if(res&&res.success){
						let list = res.data.list
						list.forEach(item=>{
							item.createdTime = formatDateOrder(item.createdTime)
							item.isEdit = false
							item.spreadUnitPriceUp = ''
						})
						this.tableData = list
						this.total = Number(res.data.total)
					}
				})
			},
			// 确认提交
			save() {
				this.$refs.formBox.validate((valid) => {
					if (valid) {
						if(!this.isVideo){
							this.$message.error('请上传视频')
							return
						}
						this.loading = true
						let data = {
							name:this.videoData.name,
							url:this.ossVideoUrl
						}
						videoCreate({data}).then(res=>{
							if(res.success){
								this.dialogVisible = false
								this.tableData = []
								this.pageNum = 1
								this.search()
							}else{
								this.loading = false
								this.$message.error(res.msg)
							}
						})
					}
				})
			},
			copyText(text){
				navigator.clipboard.writeText(text)
				this.$message.success("复制链接成功，可以粘贴")
			},
			add(){
				this.uploadProgress = 0
				this.ossVideoUrl = ''
				this.videoData.name = ''
				this.isVideo = false
				this.dialogVisible = true
			},
			closeDialog(){
				this.dialogVisible = false
			},
			delPro(id){
				this.$messageBox.confirm('是否确定删除此条数据？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(()=>{
					videoDeleteById({data:{id}}).then(res=>{
						if(res.success){
							this.$message.success('删除成功！')
							this.tableData = []
							this.search()
						}else{
							this.$message.error(res.msg)
						}
					})
				}).catch(()=>{})
			},
			handleMetadata(id) {
				const videoElement = document.getElementById(id);
				if (!videoElement) {
					return;
				}
				const aspectRatio = videoElement.videoWidth / videoElement.videoHeight;
				if (aspectRatio > 1) {
					// 宽屏视频，选择横屏展示方式
					// 这里可以通过操作CSS或其他方式来调整展示样式
					videoElement.classList.add('landscape-video');
				} else {
					// 竖屏视频，选择竖屏展示方式
					// 同样可以通过操作CSS或其他方式来调整展示样式
					videoElement.classList.add('portrait-video');
				}
			},
			handlePictureCardPreview(file, fileList,types){
				this.videosUrl.forEach((ies,index) =>{
					if(file.response){
						if(ies==file.response.data[0]){
							this.dialogImageUrl = ies
							this.dialogVisible1 = true
						}
						return
					}
					if(ies==file.url){
						this.dialogImageUrl = ies
						this.dialogVisible1 = true
					}
				});
			},
			handleRemove(file, fileList,types) {
				this.fileListData.forEach((ies,index) =>{
					if(ies.url){
						if(ies.url==file.url || (file.response?ies.url==file.response.data[0]:'')){
							this.fileListData.splice(index,1)
						}
					}else{
						if(ies==file.url || (file.response?ies==file.response.data[0]:'')){
							this.fileListData.splice(index,1)
						}
					}
				});
				this.videosUrl.forEach((ies,index) =>{
					if(ies==file.url || (file.response?ies==file.response.data[0]:'')){
						this.videosUrl.splice(index,1)
					}
				});
			},
			uploadSuccess(response, file, fileList,types) {
				console.log(response, file, fileList,types)
				return
				let uid = file.uid;
				let idx = fileList.findIndex(item => item.uid === uid)
				if(response.code.indexOf("A02")!=-1){
					fileList.splice(idx, 1)
				}
				if(response.code=="A0200"||response.code=="A0201"){// 登录过期，重新登录
					this.$store.commit("updateUserInfo", '');
					this.$router.push("/")
					return
				}
				if(response.code=="A0202"){
					this.userLogin()
					return
				}
				this.fileListData.push(response.data[0])
				this.videosUrl.push(response.data[0])
			},
			userLogin(){
				let userInfo = this.userInfo
				let postData = {
					"grantType": "PLATFORM_REFRESH_TOKEN",
					refreshTokenTokenRequest:{
						refreshToken: this.userInfo.refreshToken
					}
				}
				userLogin(postData).then(res1=>{
					userInfo.token = res1.data.accessToken;
					userInfo.refreshToken = res1.data.refreshToken;
					this.$store.commit("updateUserInfo", userInfo);
					this.importHeaders.Authorization = userInfo.token?('Bearer'+' '+ userInfo.token):''
				})
			},
			handleExceed(files, fileList) {
				this.$message.warning("当前限制选择 1 个文件");
			},
			beforeAvatarUpload(file) {
				const extension3 = file.name.endsWith(".mp4")||file.name.endsWith(".MP4");
				// const extension4 = file.name.endsWith(".avi")||file.name.endsWith(".AVI");
				// const extension5 = file.name.endsWith(".rmvb")
				// const extension6 = file.name.endsWith(".3gp")||file.name.endsWith(".3GP");
				const extension7 = file.name.endsWith(".mov")||file.name.endsWith(".MOV");
				const isLt2M = file.size / 1024 / 1024 < 500;
				if (!extension3 && !extension7) {
					this.$message({
						message: "上传模板只能是 .mp4,.mov 格式!",
						type: "error"
					});
				}
				if (!isLt2M) {
					this.$message.error("上传图片大小不能超过 2M!");
				}
				return (extension3 || extension7) && isLt2M;
				// return extension || extension1 || extension2 || extension3 || extension4 || extension5 || extension6 || extension7;
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.search()
			},
			handleCurrentChange(val) {
				this.pageNum = val;
				this.tableData = []
				this.search()
			},
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	.cardInfo{
		width:calc(100% - 210px);
	}
	.landscape-video {
		/* 横屏样式 */
		width: 200px !important;
	}
	.portrait-video {
		/* 竖屏样式 */
		width: 150px !important;
	}
	.el-progress{
		
	}
	.tablePage{
		height: calc(100vh - 220px);
		overflow-y: auto;
	}
</style>